import { btnFlags } from '@/components/widgets/product_intro/element.js'

export const language = {
  [`${btnFlags.inquireNow}`]: '{{inquiry_now}}',
  [`${btnFlags.nextProduct}`]: '{{next_product}}',
  [`${btnFlags.downloadSingle}`]: '{{product_download}}',
  [`${btnFlags.addToCart}`]: '{{order_add_to_cart}}',
  share: '{{share}}',
  'w-col home-list-download-btn': '{{download_download}}',
  'product-cate-list-btn': '{{read_more}}',
  'VIEW MORE': '{{view_more}}'
}
